// React
import { useNavigate } from "react-router-dom";
// Style
import "../../styles/menu/MenuStyle.scss";
import "../../styles/menu/AdminStyle.scss";
import { useEffect } from "react";
// Recoil
import { useSetRecoilState } from "recoil";
import { isAdminMode } from "../../atom/menu";

function CloseStore() {
  // 영업 종료 화면

  const navigate = useNavigate();
  // Recoil State
  const setIsAdminPopup = useSetRecoilState(isAdminMode);

  const tripleClick = () => {
    setIsAdminPopup(true);
  };

  useEffect(() => {
    const logoEle = document.getElementById("triple");
    if (logoEle) {
      // let clicks = 0;
      // let timer,
      //   timeout = 1000;
      logoEle.addEventListener("click", function (e) {
        // clicks++;
        // timer = setTimeout(function () {
        //   if (clicks == 3 || clicks == 4) tripleClick();
        //   clicks = 0;
        // }, timeout);
        tripleClick();
      });
    }
  }, []);

  return (
    <div className='intro-wrap'>
      <div className='menu-list-common-header' style={{ padding: 0 }}>
        <div
          id='triple'
          style={{
            backgroundColor: "#eee",
            zIndex: 9,
            padding: "0 2rem 0 1.25rem",
          }}
        >
          <img
            className='logo-img'
            src={"/assets/images/menu/logo.png"}
            alt='vd company logo'
          />
        </div>
        <div className='flow-text-box'>
          <div className='flow-gradation' style={{ top: "0" }}></div>
          <div className='flow-text TO-title-5'>
            어서오세요, 1992 덮밥&짜글이에 오신 것을 환영합니다. 매장 오픈 시간
            10:00 -18:00
          </div>
        </div>
      </div>

      <div className='flex col' style={{ height: "calc(100% - 64px)" }}>
        <div className='admin-close-wrap'>
          <div className='relative w-100' style={{ textAlign: "center" }}>
            <img src={"/assets/images/menu/ready.svg"} alt='ready icon' />
            <div
              className='TO-title-1 w-100'
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%,-50%)",
              }}
            >
              지금은 영업 준비중입니다
            </div>
          </div>
          <div className='admin-close-info'>
            <div className='admin-close-row'>
              <div className='TO-title-2-small'>매장 운영시간</div>
              <div className='TO-button-2'>오전 10시 - 오후 6 시</div>
            </div>
            <div className='admin-close-row'>
              <div className='TO-title-2-small'>브레이크 타임</div>
              <div className='TO-button-2'>오후 3시 - 오후 5 시</div>
            </div>
          </div>
          <div
            className='basic-btn white TO-button-1 pointer'
            onClick={() => {
              navigate("/menu");
            }}
          >
            직원호출
          </div>
        </div>
      </div>
    </div>
  );
}

export default CloseStore;
